// src/utils/feedingHref.js
//
// I-03 S3-07.1 (Fable ruling 6, 2026-10-13) — ONE "Feeding" page with tabs.
//
// `/facilities/<id>/feeding?tab=plan|history|foods|profiles` replaced four
// separate pages (Feeding Plan, Feeding History, Feeding Profiles, Feeder
// Status). Every link in the app that points at one of them is built HERE,
// so the URL shape is written once. The old routes still exist as
// redirects (`components/Feeding/FeedingTabRedirect.jsx`), so a bookmark or
// a FroggerAI navigate route that predates the merge still lands.

export const FEEDING_TABS = ['plan', 'history', 'foods', 'profiles'];

/** The old route path segment -> the tab that replaced it. */
export const OLD_FEEDING_ROUTES = {
  'feeding-plan': 'plan',
  'feeding-history': 'history',
  'feeder-status': 'foods',
  'feeding-profiles': 'profiles',
};

/**
 * The Feeding page's URL for one tab. `extra` (an object or a
 * URLSearchParams) rides along — Feeding History's `include_voided`, the
 * plan's `start`/`days`/`group`.
 */
export const feedingHref = (facilityId, tab = 'plan', extra = null) => {
  const params = new URLSearchParams(extra || undefined);
  params.delete('tab');
  const out = new URLSearchParams();
  out.set('tab', FEEDING_TABS.includes(tab) ? tab : 'plan');
  params.forEach((value, key) => out.append(key, value));
  return `/facilities/${facilityId}/feeding?${out.toString()}`;
};

export default feedingHref;
